<template>
  <div class="app">
    <AppHeader fixed>
      <b-link class="navbar-brand" to="/">
        <img class="navbar-brand-full mr-3" src="/img/brand/logo.svg" height="32" alt="Logo">
        <img class="navbar-brand-minimized" src="/img/brand/logo.svg" height="32" alt="Logo">
        Корпус удмуртского языка
      </b-link>
      <b-navbar-nav class="d-md-down-none mr-auto">
        <b-nav-item class="px-3" to="/home">Главная</b-nav-item>
        <b-nav-item class="px-3" to="/dictionary">Словарь</b-nav-item>
        <b-nav-item-dropdown split-variant="outline-primary" variant="primary" text="Корпус" left class="px-3">
          <b-dropdown-item to="body">Основной корпус</b-dropdown-item>
          <b-dropdown-item to="memorials">Корпус письменных памятников</b-dropdown-item>
          <b-dropdown-item to="parallel">Русско-удмуртский параллельный корпус</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item class="px-3" to="/about">О проекте</b-nav-item> 
      </b-navbar-nav>

      <a href="/admin" class="d-md-down-none ml-auto mr-5"><i class="fa dark fa-user-circle fa-lg"></i></a>

      <b-nav class="d-lg-none d-xl-none custom-ddown ml-auto">
      <b-nav-item-dropdown right no-caret>
        <template slot="button-content">
          <slot name="header"><span class="navbar-toggler-icon" /></slot>
        </template>
        <slot name="dropdown">
          <b-dropdown-item class="px-3 mt-2" to="/home">Главная</b-dropdown-item>
          <b-dropdown-item class="px-3" to="/dictionary">Словарь</b-dropdown-item>
          <b-nav-item-dropdown split-variant="outline-primary" variant="primary" text="Корпус" left class="px-3">
            <b-dropdown-item to="body">Основной корпус</b-dropdown-item>
            <b-dropdown-item to="memorials">Корпус письменных памятников</b-dropdown-item>
            <b-dropdown-item to="parallel">Русско-удмуртский параллельный корпус</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-dropdown-item class="px-3 mb-2" to="/about">О проекте</b-dropdown-item>
        </slot>
      </b-nav-item-dropdown>
      </b-nav>

    </AppHeader>
    <div class="app-body">
      <main class="main">
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <div class="_x_copy">
         <div class="mx-5 mt-2">&copy; <a href="http://udman.ru/">УдмФИЦ УрО РАН, 2019-2025</a></div>
    </div>
  </div>
</template>

<script>
import nav from '@/_nav'
import { Header as AppHeader } from '@coreui/vue'

export default {
  name: 'DefaultContainer',
  components: {
    AppHeader
  },
  data () {
    return {
      navItems: nav.items
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/style';

  .app-header .navbar-brand {
    width:344px;
    color:$black;
    font-weight:bold;
    font-size:16px;
  }

  .app-body {
    background: url(/img/brand/bg.jpg) no-repeat 50% 50%;
    background-size: cover;
  }
  .main {
    background-color: rgba(0, 0, 0, .5);
  }

._x_copy {
  flex: 0 0 35px;
  background: #FFFFFF;
  font-size: 12px;
  a { color:#000; }
}

@include media-breakpoint-down($breakpoint-mobile-down) {
  .app-header {
    .navbar-brand {
      left: 3rem;
    }
  }
}
</style>
